module.exports = __webpack_public_path__ + "h5/img/live-logo.0059d362.png";